import { render, staticRenderFns } from "./EditBudgetPage.vue?vue&type=template&id=55c0f79f&scoped=true"
import script from "./EditBudgetPage.vue?vue&type=script&lang=js"
export * from "./EditBudgetPage.vue?vue&type=script&lang=js"
import style0 from "./EditBudgetPage.vue?vue&type=style&index=0&id=55c0f79f&prod&lang=scss&scoped=true"
import style1 from "./EditBudgetPage.vue?vue&type=style&index=1&id=55c0f79f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c0f79f",
  null
  
)

export default component.exports